import { supabase } from './supabase';
import { createIdempotencyKey } from './assistantClient';
import type { CategoryId } from '../types';

type FinanceCommand = {
  kind: 'create_expense' | 'create_income' | 'create_fixed_expense';
  description: string;
  amount: number;
  date?: string | null;
  month: number;
  year: number;
  category?: CategoryId | null;
  paymentMethod?: string | null;
  participantId?: string | null;
  paid?: boolean;
  dueDay?: number | null;
};

export async function runFinanceCommand(command: FinanceCommand) {
  const { data, error } = await supabase.functions.invoke('finance-command', {
    body: { command: { ...command, idempotencyKey: createIdempotencyKey(), source: 'manual' } },
  });
  if (error) throw new Error(error.message || 'Não foi possível salvar o lançamento.');
  if (!data?.ok || !data?.result) throw new Error(data?.error || 'Não foi possível salvar o lançamento.');
  return data.result as { id: string };
}
